<style>
  /* 自定义用户下拉框样式 */
  .custom-user-dropdown {
    position: relative;
    width: 100%;
  }

  .custom-user-dropdown input.form--text-field {
    width: 100%;
    padding-right: 40px;
    min-height: 40px;
    font-size: 14px;
    cursor: pointer;
    background-color: #fff;
  }

  .dropdown-arrow {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    font-size: 12px;
    color: #666;
    pointer-events: auto;
  }

  .user-dropdown-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #fff;
    border: 1px solid #ddd;
    border-top: none;
    max-height: 300px;
    overflow-y: auto;
    z-index: 10000;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    margin-top: 2px;
  }

  .user-option {
    padding: 12px 15px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.5;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s;
  }

  .user-option:hover {
    background-color: #f5f5f5;
  }

  .user-option.selected {
    background-color: #e8f4fd;
    font-weight: 500;
  }

  .user-option:last-child {
    border-bottom: none;
  }

  .no-results {
    padding: 12px 15px;
    color: #999;
    font-size: 14px;
    text-align: center;
  }

  /* 确保下拉面板不被父容器裁剪 */
  .signature-edit-modal .form--field {
    overflow: visible !important;
  }
  .op-modal--modal-body {
    overflow: visible !important;
  }
</style>

<div class="op-modal--portal signature-edit-modal ngdialog-theme-openproject">
  <div class="op-modal--modal-container signature-edit--modal"
       tabindex="0">
    <div class="op-modal--modal-header">
      <a class="op-modal--modal-close-button">
        <i class="icon-close"
           (click)="closeMe($event)"
           title="Close">
        </i>
      </a>
      <h3 class="icon-context icon-edit">Edit Signature</h3>
    </div>

    <div class="ngdialog-body op-modal--modal-body">
      <!-- 错误信息 -->
      <div class="notification-box -error" *ngIf="error">
        <span class="icon-context icon-error"></span>
        <p>{{ error }}</p>
      </div>

      <!-- 角色选择 -->
      <div class="form--field">
        <label class="form--label">Select Role</label>
        <div class="form--group">
          <label class="form--label-checkbox" *ngFor="let role of roleTypes">
            <input type="radio"
                   name="role"
                   [value]="role.key"
                   [(ngModel)]="selectedRole"
                   (change)="onRoleChange(role.key)">
            <span class="form--label-checkbox-content">{{ role.label }}</span>
          </label>
        </div>
      </div>

      <!-- 签名人选择 -->
      <div class="form--field">
        <label class="form--label">Select Signer ({{ currentRoleLabel }})</label>
        <div class="custom-user-dropdown" (click)="$event.stopPropagation()">
          <!-- 搜索输入框 -->
          <input
            type="text"
            class="form--text-field"
            [value]="selectedUserName"
            (click)="toggleUserDropdown(); $event.stopPropagation()"
            placeholder="Search user..."
            readonly>

          <!-- 下拉箭头 -->
          <span class="dropdown-arrow" (click)="toggleUserDropdown(); $event.stopPropagation()">▼</span>

          <!-- 下拉列表 -->
          <div *ngIf="showUserDropdown" class="user-dropdown-list" [style.max-height]="dropdownMaxHeight" (click)="$event.stopPropagation()">
            <div
              *ngFor="let user of filteredUsers"
              class="user-option"
              (click)="selectUser(user); $event.stopPropagation()"
              [class.selected]="selectedUserId === user.id">
              {{ user.name }}
            </div>
            <div *ngIf="filteredUsers.length === 0" class="no-results">
              No users found
            </div>
          </div>
        </div>
      </div>

      <!-- 签名日期选择 -->
      <div class="form--field">
        <label class="form--label">Select Signature Date ({{ currentRoleLabel }})</label>
        <input
          #dateInput
          id="signatureDateInput"
          class="form--text-field"
          type="text"
          [value]="selectedDate"
          placeholder="Select date and time"
          style="cursor: pointer;">
      </div>

      <!-- 加载指示器 -->
      <div class="loading-indicator" *ngIf="loading">
        <span class="loading-indicator--message">Updating...</span>
      </div>
    </div>

    <div class="op-modal--modal-footer">
      <button class="button -secondary"
              (click)="closeMe($event)"
              [disabled]="loading"
              title="Cancel">
        Cancel
      </button>
      <button class="button -highlight"
              (click)="submit()"
              [disabled]="loading"
              title="Update Signature">
        Update
      </button>
    </div>
  </div>
</div>
